import React, { useContext } from 'react'
import MyContext from '../../context/data/myContext';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

function SearchBar2() {
    const context = useContext(MyContext)
    const { filteredData2, wordEntered2, handleFilter2, clearInput2 } = context
  return (
    <div>
        <div className="ml-auto flex items-center">
              <input type="text" placeholder='Buscar...' value={wordEntered2} onChange={handleFilter2} style={{outline: 'none'}} className='bg-gray-100'/>
                <div>
                    {filteredData2.length === 0 ? (<SearchIcon/>) : (<CloseIcon  id="clearBtn" onClick={clearInput2} />) }
                </div>
              </div>
      
    </div>
  )
}

export default SearchBar2